import defaultSettings from '@/settings'

const title = defaultSettings.title || '东乐 e 聘'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${title}`
    // return `${pageTitle} - ${title}`
  }
  return `${title}`
}
